import { defineComponent } from 'vue'
import styles from './styles.module.scss'
import { useComponentStore } from '@/pages/chargermap/nsh5/localStores/component'
import Tracker from '@nio-fe/nio-tracker-web'

/**
 * 县县通模式定位图标
 */
export default defineComponent({
  name: 'county-layout-position-icon-view',
  emits: ['handleCountyLayoutLocation'],

  setup: (props, { emit }) => {
    const componentStore = useComponentStore()
    const handleCountyLayoutLocation = () => {
      componentStore.bus.emit('flyToCountyLayoutLocationCity') // 切换tab还原点击的marker
      emit('handleCountyLayoutLocation')
      Tracker.track('h5_page_tracker', {
        channel: window.channel,
        client: window.client,
        brand: (process.config as any).brand,
        screen_orientation: window.screen_orientation,
        view_mode: componentStore.viewMode,
        container: window.container,
        user_identity: window.user_identity,
        trigger: 'click',
        element: '县县通定位城市按钮',
        page_source: window.page_source,
      })
    }
    return () => (
      <div
        class={['icon', 'square', 'location', styles.location]}
        onClick={handleCountyLayoutLocation}
      >
        <ns-icon
          name={(process.config as any).icon.icon_county_location}
          size={window.client === 'mobile' ? '20px' : '24px'}
        />
      </div>
    )
  },
})
